<template>
  <div class="expired-admin">
    <div class="expired-admin__guide">
      <h1>본 계정은 접속이 차단되었습니다.</h1>
      <p>이용 기간이 만료되었거나 플랜 등록 정보를 확인할 수 없습니다.</p>
      <a
        href="https://bit.ly/3iz9QYi"
        target="_blank"
      >
        <el-button class="default">
          계정 활성화
        </el-button>
      </a>
      <router-link to="/">
        <el-button class="default expired-admin__logout">
          로그아웃
        </el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpiredAdmin',
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss">
.expired-admin {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: 0;
  background-image: url('//cdn.fiflbox.com/admin/expired-background-desktop.jpg');
  display: flex;
  align-items: center;
  justify-content: center;

  .expired-admin__guide {
    width: 400px;

    h1 {
      font-size: 24px;
      line-height: 36px;
      color: #202020;
      letter-spacing: -1.5px;
      text-align: center;
      margin-bottom: 15px;
    }

    p {
      line-height: 24px;
      font-size: 16px;
      color: #202020;
      letter-spacing: -0.8px;
      text-align: center;
    }

    .el-button {
      margin: 0;
    }
  }

  @media screen and (max-width: 768px) {
    background-image: url('//cdn.fiflbox.com/admin/expired-background-mobile.jpg');

    .expired-admin__guide {
      width: 260px;

      h1 {
        line-height: 29px;
        font-size: 20px;
        color: #202020;
        letter-spacing: -1.25px;
        text-align: center;
      }

      p {
        font-size: 15px;
        color: #202020;
        letter-spacing: -0.75px;
        text-align: center;
      }
    }
  }

  .el-button.expired-admin__logout {
    background-color: transparent;
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
